import { STPathShadeType } from '@tencent/slide-sdk-model';
import { GradientType } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';

// 渐变类型 - sdk对上层类型映射
export const PATH_SHADE_TYPE_MAP = new Map([
    [STPathShadeType?.circle, GradientType.Radial],
    [STPathShadeType?.PBDEFAULT, GradientType.Linear],
    [STPathShadeType?.shape, GradientType.Shape],
    [STPathShadeType?.rect, GradientType.Rect],
]);
